module.exports = __webpack_public_path__ + "static/media/ph-top.471567bd.png";